import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/v1/admin/emails', (schema, { queryParams: { business_profile_id } }) => {
        const { models } = schema.emails.where(email => email.business_profile_id === business_profile_id);

        return models;
    });

    server.post('/v1/admin/emails', (schema, { requestBody }) => {
        requestBody = JSON.parse(requestBody);

        const { attrs } = schema.emails.create(requestBody);

        return attrs;
    });

    server.patch('/v1/admin/emails/:id', (schema, { params: { id }, requestBody }) => {
        const email = schema.emails.find(id);

        if (!email) {
            return new Response(HTTP.NOT_FOUND);
        }

        requestBody = JSON.parse(requestBody);

        email.update(requestBody);

        return email.attrs;
    });

    server.delete('/v1/admin/emails/:id', (schema, { params: { id } }) => {
        const email = schema.emails.find(id);

        if (email) {
            email.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });

    server.post('/v1/admin/mailers', () => new Response(HTTP.NO_CONTENT));
};
